import PipelineHomeContainer from './PipelineHomeContainer';

export default PipelineHomeContainer;
